export default "__VITE_ASSET__b267d4e7__"